/* Vogue Bazaar — showcase.js
   Product showcase motion: 3D tilt on cards, magnetic buttons, Spotlight coverflow,
   pinned scroll Reel, hover-expand Gallery. Loaded with defer after motion.js. */
(function () {
  'use strict';
  const T = window.theme || {};
  const S = T.motion || {};
  const html = document.documentElement;
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const motionOn = S.enabled !== false && !reduced;
  const fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  const clamp = (v, a, b) => Math.max(a, Math.min(b, v));
  const drawerMode = () => !!(S.cartType === 'drawer' && document.getElementById('CartDrawer'));

  /* ---------- 3D tilt on product cards (pointer devices only) ---------- */
  if (S.cardTilt !== false && motionOn && fine) {
    html.classList.add('card-tilt');
    let cur = null;
    const reset = el => { el.classList.remove('is-tilting'); el.style.transform = ''; };
    document.addEventListener('pointermove', e => {
      const top = e.target.closest ? e.target.closest('.card__top') : null;
      if (top !== cur) {
        if (cur) reset(cur);
        cur = top;
        if (top) {
          top.classList.add('is-tilting');
          if (!$('.card__glare', top)) { const g = document.createElement('span'); g.className = 'card__glare'; top.append(g); }
        }
      }
      if (!top) return;
      const r = top.getBoundingClientRect();
      if (!r.width) return;
      const px = clamp((e.clientX - r.left) / r.width, 0, 1), py = clamp((e.clientY - r.top) / r.height, 0, 1);
      const rx = (0.5 - py) * 14, ry = (px - 0.5) * 14;
      top.style.transform = `rotateX(${rx.toFixed(2)}deg) rotateY(${ry.toFixed(2)}deg) translateZ(0)`;
      top.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
      top.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
    }, { passive: true });
    document.addEventListener('pointerout', e => { if (cur && !cur.contains(e.relatedTarget)) { reset(cur); cur = null; } });
    document.addEventListener('scroll', () => { if (cur) { reset(cur); cur = null; } }, { passive: true });
  }

  /* ---------- magnetic buttons ---------- */
  if (motionOn && fine) {
    document.addEventListener('pointermove', e => {
      const b = e.target.closest ? e.target.closest('[data-magnet]') : null;
      if (!b) return;
      const r = b.getBoundingClientRect();
      const dx = (e.clientX - (r.left + r.width / 2)) / r.width, dy = (e.clientY - (r.top + r.height / 2)) / r.height;
      b.style.transform = `translate(${(dx * 10).toFixed(1)}px, ${(dy * 10).toFixed(1)}px)`;
    }, { passive: true });
    document.addEventListener('pointerout', e => {
      const b = e.target.closest ? e.target.closest('[data-magnet]') : null;
      if (b && !b.contains(e.relatedTarget)) b.style.transform = '';
    });
  }

  /* ---------- Spotlight: 3D coverflow ---------- */
  $$('[data-spotlight]').forEach(sec => {
    const stage = $('.spot__stage', sec), items = $$('.spot__item', sec), n = items.length;
    if (!stage || !n) return;
    const cap = $('.spot__caption', sec), dotsBox = $('.spot__dots', sec);
    const speed = (parseFloat(sec.dataset.autoplay) || 0) * 1000;
    const spread = n >= 7 ? 3 : 2;
    let active = 0, timer = null, down = null, moved = false;

    const dots = dotsBox ? items.map((_, i) => {
      const d = document.createElement('button');
      d.type = 'button'; d.className = 'spot__dot'; d.setAttribute('aria-label', 'Show product ' + (i + 1));
      d.addEventListener('click', () => go(i, true));
      dotsBox.append(d); return d;
    }) : [];

    function paintCaption() {
      if (!cap) return;
      const d = items[active].dataset;
      cap.classList.add('is-swap'); void cap.offsetWidth;
      const set = (sel, v) => { const el = $(sel, cap); if (el) el.textContent = v || ''; };
      set('[data-cap-vendor]', d.vendor); set('[data-cap-title]', d.title);
      const price = $('[data-cap-price]', cap);
      if (price) {
        price.textContent = '';
        const p = document.createElement('span'); p.textContent = d.price || ''; price.append(p);
        if (d.compare) { const s = document.createElement('s'); s.textContent = d.compare; price.append(s); }
        if (d.off) { const o = document.createElement('span'); o.className = 'off'; o.textContent = `(${d.off}% OFF)`; price.append(o); }
      }
      const link = $('[data-cap-link]', cap); if (link) link.href = d.url || '#';
      const add = $('[data-cap-add]', cap); if (add) { add.hidden = !d.variant; add.dataset.variant = d.variant || ''; }
      requestAnimationFrame(() => requestAnimationFrame(() => cap.classList.remove('is-swap')));
    }

    function layout() {
      items.forEach((it, i) => {
        let off = i - active;
        if (off > n / 2) off -= n; else if (off < -n / 2) off += n;
        const a = Math.abs(off);
        const x = off * 62, z = a ? -a * 170 - 60 : 0, ry = -off * 28, s = 1 - a * 0.08;
        it.style.transform = `translate3d(${x}%, 0, ${z}px) rotateY(${ry}deg) scale(${s.toFixed(3)})`;
        it.style.zIndex = String(20 - a);
        it.classList.toggle('is-active', off === 0);
        it.classList.toggle('is-hidden', a > spread);
        it.setAttribute('aria-hidden', off === 0 ? 'false' : 'true');
        const link = $('a', it); if (link) link.tabIndex = off === 0 ? 0 : -1;
      });
      dots.forEach((d, i) => d.setAttribute('aria-current', i === active ? 'true' : 'false'));
      paintCaption();
    }
    function go(i, user) { active = ((i % n) + n) % n; layout(); if (user) restart(); }
    const next = user => go(active + 1, user), prev = user => go(active - 1, user);

    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { stop(); if (speed && motionOn && n > 1) timer = setInterval(() => next(false), speed); }
    function restart() { start(); }

    // arrows / keyboard
    $$('[data-spot-prev]', sec).forEach(b => b.addEventListener('click', () => prev(true)));
    $$('[data-spot-next]', sec).forEach(b => b.addEventListener('click', () => next(true)));
    stage.addEventListener('keydown', e => {
      if (e.key === 'ArrowRight') { e.preventDefault(); next(true); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); prev(true); }
    });

    // click: side item -> bring to front; active item -> follow link
    stage.addEventListener('click', e => {
      const it = e.target.closest('.spot__item');
      if (!it) return;
      if (moved) { e.preventDefault(); moved = false; return; }
      if (!it.classList.contains('is-active')) { e.preventDefault(); go(items.indexOf(it), true); }
    });

    // drag / swipe
    stage.addEventListener('pointerdown', e => { if (e.button !== 0) return; down = { x: e.clientX, y: e.clientY }; moved = false; stop(); });
    stage.addEventListener('pointermove', e => {
      if (down && Math.abs(e.clientX - down.x) > 8) moved = true;
      if (fine && motionOn) {
        const r = stage.getBoundingClientRect();
        stage.style.setProperty('--mx', (((e.clientX - r.left) / r.width) * 2 - 1).toFixed(3));
        stage.style.setProperty('--my', (((e.clientY - r.top) / r.height) * 2 - 1).toFixed(3));
      }
    }, { passive: true });
    const up = e => {
      if (down) {
        const dx = e.clientX - down.x;
        if (dx < -40) next(true); else if (dx > 40) prev(true); else start();
      }
      down = null;
    };
    stage.addEventListener('pointerup', up);
    stage.addEventListener('pointercancel', () => { down = null; start(); });
    stage.addEventListener('pointerleave', e => { up(e); stage.style.setProperty('--mx', '0'); stage.style.setProperty('--my', '0'); });

    // pause while hovered / focused / tab hidden
    sec.addEventListener('pointerenter', stop);
    sec.addEventListener('pointerleave', start);
    sec.addEventListener('focusin', stop);
    sec.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));

    // add to bag from the caption
    const addBtn = $('[data-cap-add]', cap || sec);
    if (addBtn) addBtn.addEventListener('click', async () => {
      const id = parseInt(addBtn.dataset.variant || '0', 10);
      if (!id || !T.cartAdd) return;
      addBtn.disabled = true;
      try {
        await T.cartAdd(id, 1, $('img', items[active]));
        addBtn.classList.add('is-success'); setTimeout(() => addBtn.classList.remove('is-success'), 1600);
        if (!drawerMode() && T.toast) T.toast(T.strings.added, T.strings.goToBag, T.routes.cart);
      } catch (err) { if (T.toast) T.toast(err.message || 'Could not add to bag'); }
      addBtn.disabled = false;
    });

    layout(); start();
  });

  /* ---------- Reel: pinned horizontal scroll ---------- */
  $$('[data-reel]').forEach(reel => {
    const track = $('.reel__track', reel), items = $$('.reel__item', reel), count = $('[data-reel-count]', reel);
    if (!track || !items.length) return;
    const flat = () => !motionOn || window.innerWidth < 750;
    let max = 0, raf = false;

    function paint() {
      raf = false;
      if (flat()) return;
      const r = reel.getBoundingClientRect();
      const p = clamp(-r.top / Math.max(1, max), 0, 1);
      track.style.transform = `translate3d(${(-p * max).toFixed(1)}px, 0, 0)`;
      reel.style.setProperty('--p', p.toFixed(4));
      const cx = window.innerWidth / 2;
      let best = 0, bestD = Infinity;
      items.forEach((it, i) => {
        const b = it.getBoundingClientRect();
        const d = (b.left + b.width / 2 - cx) / window.innerWidth, ad = Math.abs(d);
        if (ad < bestD) { bestD = ad; best = i; }
        it.style.setProperty('--s', (1 - clamp(ad, 0, 1) * 0.12).toFixed(3));
        it.style.setProperty('--ty', (clamp(ad, 0, 1) * 28).toFixed(1) + 'px');
        const img = $('img, .placeholder-svg', it); if (img) img.style.setProperty('--py', (d * -40).toFixed(1) + 'px');
      });
      if (count) count.textContent = String(best + 1).padStart(2, '0');
    }
    function measure() {
      if (flat()) { reel.classList.add('is-flat'); reel.style.height = ''; track.style.transform = ''; return; }
      reel.classList.remove('is-flat');
      track.style.transform = 'none';
      const pad = parseFloat(getComputedStyle(track).paddingLeft) || 0;
      const last = track.lastElementChild;
      const right = last ? last.getBoundingClientRect().right - track.getBoundingClientRect().left : 0;
      max = Math.max(0, Math.round(right + pad - window.innerWidth));
      reel.style.height = (window.innerHeight + max) + 'px';
      paint();
    }
    const onScroll = () => { if (!raf) { raf = true; requestAnimationFrame(paint); } };
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    $$('img', track).forEach(img => { if (!img.complete) img.addEventListener('load', measure, { once: true }); });
    measure();
  });

  /* ---------- Gallery: hover-expand accordion ---------- */
  $$('[data-accordion]').forEach(row => {
    const panels = $$('.acc__panel', row);
    if (!panels.length) return;
    const auto = parseFloat(row.dataset.auto) || 0;
    let idx = panels.findIndex(p => p.classList.contains('is-open')), timer = null;
    if (idx < 0) { idx = 0; panels[0].classList.add('is-open'); }
    const open = i => { idx = i; panels.forEach((p, k) => p.classList.toggle('is-open', k === i)); };
    const stop = () => { if (timer) { clearInterval(timer); timer = null; } };
    const start = () => { stop(); if (auto && motionOn) timer = setInterval(() => open((idx + 1) % panels.length), auto * 1000); };
    panels.forEach((p, i) => {
      p.addEventListener('pointerenter', () => { if (fine) open(i); });
      p.addEventListener('focus', () => open(i));
      p.addEventListener('click', e => { if (!p.classList.contains('is-open')) { e.preventDefault(); open(i); } });
    });
    row.addEventListener('pointerenter', stop);
    row.addEventListener('pointerleave', start);
    start();
  });
})();
